import axios from "../javascript/custom-axios";
const RESOURCE_NAME = "v1/notifications";

export default {
  getNotifications(PageSize = 15, Page = 1) {
    return axios.get(`/admin/get-notifications`, {
      params: { PageSize, Page },
    });
  },
  createNotification(body) {
    return axios.post(`${RESOURCE_NAME}/create`, body);
  },
  deleteNotification(id) {
    return axios.put(`${RESOURCE_NAME}/${id}`);
  },
};
